import { useGoogleLogin } from "@react-oauth/google";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import makeRequest from "../../../api";
import { authService, trainerService } from "../../../api/services";
import { gabitNameIcon } from "../../../assets/svg";
import TrainerContext from "../../../context/trainerContext/TrainerContext";
import styles from "./Login.module.scss";

const LoginComponent = () => {
  const navigate = useNavigate();
  const { setTrainerState, getTrainerState } = useContext(TrainerContext);
  const trainerData = getTrainerState();

  useEffect(() => {
    const token = trainerData?.token;
    if (token !== "") {
      navigate("/");
    }
  }, [trainerData]);

  const getTrainerDetails = async (userId: any) => {
    try {
      const res = await makeRequest(
        trainerService.getTrainerData(
          {
            trainerId: userId,
          },
          userId
        )
      );
      return res?.data;
    } catch (error: any) {
      toast.error("Error while fetching trainer details!");
    }
  };

  const login = useGoogleLogin({
    onSuccess: async (codeResponse: any) => {
      const ssoAccessToken = codeResponse?.access_token || "";
      try {
        const res = await makeRequest(
          authService.verfiySSOToken({
            idp: "GOOGLE",
            idpToken: ssoAccessToken,
          })
        );

        const trainerData = {
          trainerId: res?.data?.userId,
          token: res?.data?.idToken,
          refreshToken: res?.data?.refreshToken,
        };

        setTrainerState({
          ...trainerData,
        });

        getTrainerDetails(trainerData?.trainerId).then((res) => {
          setTrainerState({
            ...trainerData,
            trainerCategory: res?.trainer?.category,
            trainerName: res?.trainer?.name,
            trainerEmail: res?.trainer?.email,
            trainerIsAdmin: res?.trainer?.category === "ADMIN",
            permissions: res?.trainer?.permissions
              ? [...res?.trainer?.permissions]
              : [],
            trainerDescription: res?.trainer?.description,
            trainerImage: res?.trainer?.imgURL ?? "",
          });
        });

        navigate("/");
      } catch (err) {
        toast.error("Login Failed");
      }
    },
    onError: () => toast.error("Login Failed"),
  });

  return (
    <div
      className={`${styles.loginPage} d-flex align-items-center justify-content-center flex-column`}
    >
      <img src={gabitNameIcon} alt="" />
      <button
        className="btn btn-outline-dark"
        onClick={() => {
          login();
        }}
      >
        Sign in with Google 🚀
      </button>
    </div>
  );
};

export default LoginComponent;
